<div class="p-4">
  <h3 class="text-lg font-semibold mb-4">Choisir un mode de paiement</h3>

  <!-- Cards list -->
  <div class="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6">
    <div
      *ngFor="let type of paymentTypes"
      (click)="selectPayment(type.id)"
      role="button"
      tabindex="0"
      class="flex items-center gap-3 p-3 rounded-lg border hover:shadow cursor-pointer transition
            "
      [ngClass]="{
        'border-primary bg-primary/5': selectedPaymentType === type.id,
        'border-gray-200 bg-white': selectedPaymentType !== type.id
      }"
      (keydown.enter)="selectPayment(type.id)"
    >
      <div class="w-10 h-10 flex items-center justify-center rounded-md bg-gray-50">
        <img *ngIf="type.icon" [src]="type.icon" [alt]="type.label" class="w-6 h-6" />
        <span *ngIf="!type.icon" class="text-sm font-medium">{{ type.label | slice:0:1 }}</span>
      </div>
      <div class="flex-1">
        <div class="text-sm font-medium">{{ type.label }}</div>
        <div class="text-xs text-gray-500">{{ type.description || '' }}</div>
      </div>
      <div class="w-5">
        <svg *ngIf="selectedPaymentType === type.id" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
    </div>
  </div>

  <!-- Dynamic form area: show form for the selected payment type -->
  <div *ngIf="selectedPaymentType" class="p-4 border border-gray-200 rounded-lg bg-white">
    <h4 class="text-sm font-semibold mb-3">Informations pour : <span class="text-primary">{{ selectedPaymentType }}</span></h4>

    <form [formGroup]="paymentForm" (ngSubmit)="submitPayment()" class="space-y-4">
      <ng-container [ngSwitch]="selectedPaymentType">

        <!-- Cards: mastercard_card, tokenized_card -->
        <div *ngSwitchCase="'mastercard_card'">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div class="flex flex-col">
              <label class="text-xs text-gray-700">Numéro de carte</label>
              <input formControlName="cardNumber" type="text" inputmode="numeric" maxlength="19"
                class="input border" placeholder="XXXX XXXX XXXX XXXX" />
              <div *ngIf="paymentForm.get('cardNumber')?.invalid && paymentForm.get('cardNumber')?.touched" class="text-red-500 text-xs mt-1">
                Numéro de carte invalide
              </div>
            </div>

            <div class="flex gap-2">
              <div class="flex-1 flex flex-col">
                <label class="text-xs text-gray-700">Date d'expiration</label>
                <input formControlName="expiry" type="text" placeholder="MM/AA" maxlength="5" class="input border" />
              </div>
              <div class="flex-1 flex flex-col">
                <label class="text-xs text-gray-700">CVV</label>
                <input formControlName="cvv" type="password" maxlength="4" class="input border" placeholder="123" />
              </div>
            </div>

            <div class="col-span-1 sm:col-span-2 flex flex-col">
              <label class="text-xs text-gray-700">Nom du titulaire</label>
              <input formControlName="cardHolder" type="text" class="input border" placeholder="Nom sur la carte" />
            </div>
          </div>
        </div>

        

        <!-- Mobile money types: orange_money, mtn_money, free_money, wave_money, maxit -->
        <div *ngSwitchCase="'orange_money'">
          <div class="flex flex-col gap-3">
            <label class="text-xs text-gray-700">Numéro Orange</label>
            <input formControlName="phone" type="tel" inputmode="tel" class="input border" placeholder="221XXXXXXXX" />
            <label class="text-xs text-gray-700">Nom du titulaire</label>
            <input formControlName="holderName" type="text" class="input border" placeholder="Nom" />
            <div class="text-xs text-gray-500">Un OTP pourra être requis pour confirmer le paiement.</div>
          </div>
        </div>

       

        <div *ngSwitchCase="'free_money'">
          <div class="flex flex-col gap-3">
            <label class="text-xs text-gray-700">Numéro Free</label>
            <input formControlName="phone" type="tel" class="input border" placeholder="221XXXXXXXX" />
            <label class="text-xs text-gray-700">Nom du titulaire</label>
            <input formControlName="holderName" type="text" class="input border" placeholder="Nom" />
          </div>
        </div>

        <div *ngSwitchCase="'wave_money'">
          <div class="flex flex-col gap-3">
            <label class="text-xs text-gray-700">Numéro Wave</label>
            <input formControlName="phone" type="tel" class="input border" placeholder="221XXXXXXXX" />
            <label class="text-xs text-gray-700">Nom complet</label>
            <input formControlName="holderName" type="text" class="input border" placeholder="Nom" />
          </div>
        </div>

        <div *ngSwitchCase="'maxit'">
          <div class="flex flex-col gap-3">
            <label class="text-xs text-gray-700">Numéro Maxit</label>
            <input formControlName="phone" type="tel" class="input border" placeholder="221XXXXXXXX" />
            <label class="text-xs text-gray-700">Nom du titulaire</label>
            <input formControlName="holderName" type="text" class="input border" placeholder="Nom" />
          </div>
        </div>

        <!-- Fallback -->
        <div *ngSwitchDefault class="text-sm text-gray-600">
          Formulaire indisponible pour ce moyen de paiement.
        </div>
      </ng-container>

      <div class="flex justify-end gap-3 pt-3">
        <button type="button" (click)="cancelPayment()" class="px-4 py-2 bg-gray-100 rounded text-sm">Annuler</button>
        <button type="submit" [disabled]="paymentForm.invalid || isProcessing" class="px-4 py-2 bg-primary text-white rounded text-sm flex items-center gap-2">
          <div *ngIf="isProcessing" class="h-4 w-4 border-b-2 border-white rounded-full animate-spin"></div>
          <span>{{ isProcessing ? 'Traitement...' : 'Payer' }}</span>
        </button>
      </div>
    </form>
  </div>

   <!-- QR display -->
  <div *ngIf="qrImageUrl" class="mt-4 p-4 border border-gray-200 rounded-lg bg-white flex flex-col items-center gap-3">
    <div class="text-sm font-semibold">Scannez ce QR pour confirmer le paiement</div>

    <img [src]="qrImageUrl" alt="QR Code paiement" class="max-w-xs w-48 h-48 object-contain rounded-md shadow-sm" />

    <div class="text-xs text-gray-500">
      <span *ngIf="polling">Attente de confirmation du paiement... ({{ pollAttempts }} / {{ maxPollAttempts }})</span>
      <span *ngIf="!polling">QR généré — scannez depuis votre application de paiement.</span>
    </div>

    <div class="flex gap-2 mt-2">
      <a *ngIf="qrImageUrl" [href]="qrImageUrl" download="payment-qr.png" class="px-3 py-1 bg-gray-100 rounded text-sm">Télécharger</a>
      <button type="button" (click)="closeQr()" class="px-3 py-1 bg-red-500 text-white rounded text-sm">Annuler / Fermer</button>
    </div>
  </div>
  <!-- no selection -->
  <div *ngIf="!selectedPaymentType" class="text-sm text-gray-500">
    Sélectionnez un mode de paiement pour afficher le formulaire correspondant.
  </div>
</div>
